import { SvgIcon, SvgIconProps } from '@material-ui/core';
import React from 'react';

type CompletedIconProps = SvgIconProps;

export const CompletedIcon: React.FC<CompletedIconProps> = props => (
  <SvgIcon viewBox="0 0 245 233" fill="none" {...props}>
    <path
      d="M122.5 225.999C182.423 225.999 231 177.422 231 117.5C231 57.5769 182.423 9 122.5 9C62.5771 9 14 57.5769 14 117.5C14 177.422 62.5771 225.999 122.5 225.999Z"
      fill="url(#paint0_linear_1417_1911)"
    />
    <path
      d="M189.53 66.8758C187.082 64.5547 183.764 63.2511 180.304 63.2511C176.845 63.2511 173.527 64.5547 171.078 66.8758L101.082 133.372C100.93 133.519 100.748 133.636 100.548 133.715C100.348 133.795 100.133 133.836 99.9157 133.836C99.6985 133.836 99.4836 133.795 99.2833 133.715C99.083 133.636 98.9014 133.519 98.7491 133.372L78.617 114.246C77.4122 113.066 75.9724 112.126 74.3814 111.479C72.7904 110.833 71.0799 110.493 69.3495 110.481C67.6192 110.468 65.9035 110.783 64.3022 111.406C62.701 112.029 61.2463 112.949 60.0227 114.111C58.7991 115.274 57.8311 116.656 57.175 118.177C56.5189 119.698 56.1878 121.328 56.2011 122.972C56.2143 124.616 56.5715 126.241 57.2519 127.752C57.9324 129.264 58.9226 130.631 60.1647 131.776L96.5226 166.316C97.4211 167.167 98.6384 167.646 99.9074 167.646C101.176 167.646 102.394 167.167 103.292 166.316L189.51 84.4087C191.957 82.0846 193.334 78.9333 193.338 75.6462C193.341 72.3591 191.972 69.2049 189.53 66.8758Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1417_1911"
        x1="122.5"
        y1="9"
        x2="122.5"
        y2="226.002"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#81FBB8" />
        <stop offset="1" stop-color="#28C76F" />
      </linearGradient>
    </defs>
  </SvgIcon>
);
